module.exports = __webpack_public_path__ + "fonts/MyriadPro-Cond.79f55b0.ttf";